import type { ChatContactInfo, Chat, Contact } from '../domain/Chat'
import type { RawContact, RawChat, RawChatContactInfo } from './ChatRepository'

export function mapApiToChat(rawChat: RawChat): Chat {
  return {
    uuid: rawChat.uuid,
    subject: rawChat.subject,
    lastMessage: rawChat.last_message
      ? {
          createdAt: rawChat.last_message.created_at,
          text: rawChat.last_message.text,
          isUnread: rawChat.last_message.is_unread,
        }
      : undefined,
    participants: rawChat.participants,
    type: rawChat.type,
    context: rawChat.context
      ? {
          source: rawChat.context.source,
          entityName: rawChat.context.entity_name,
          entityIdentifier: rawChat.context.entity_pk,
        }
      : undefined,
  }
}

export function mapApiToContact(rawContact: RawContact): Contact {
  return {
    uuid: rawContact.account.uuid,
    name: rawContact.account.name,
    email: rawContact.account.email,
    type: rawContact.type || undefined,
  }
}

export function mapApiToChatContactInfo(rawChatContactInfo: RawChatContactInfo): ChatContactInfo {
  return {
    name: rawChatContactInfo.name || undefined,
    email: rawChatContactInfo.email,
    uuid: rawChatContactInfo.uuid,
    phone: rawChatContactInfo.phone || undefined,
    talkJsToken: rawChatContactInfo.talkjs_token,
  }
}
